import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import GriefStages from '../components/GriefStages';
import AnticipatorGrief from '../components/AnticipatorGrief';
import CopingMechanisms from '../components/CopingMechanisms';
import CounselorContact from '../components/CounselorContact';
import Resources from '../components/Resources';
import GriefVideos from '../components/GriefVideos';
import ImageSection from '../components/ImageSection';
import AdSense from '../components/AdSense';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      
      {/* First AdSense Slot */}
      <AdSense slot={1} />
      
      <GriefStages />
      
      <AnticipatorGrief />
      
      {/* Second AdSense Slot */}
      <AdSense slot={2} />
      
      <CopingMechanisms />
      
      <CounselorContact />
      
      <Resources />
      
      <GriefVideos />
      
      <ImageSection />
      
      {/* Third AdSense Slot */}
      <AdSense slot={3} />
      
      <Footer />
    </div>
  );
};

export default Home;
